<!-- <div class="d-flex p-0">
    <div class="bg-color text-white p-4 col-12 w-50">
        <h5 class="mb-4 text-white fw-bold">Why register with us?</h5>
        <ul class="">
            <li>With totally online Admission Process we help you get college admission without having to
                step out</li>
            <li>Up to 50% discount on application forms</li>
            <li>Upload your admission documents and get Paytm rewards</li>
            <li>You won’t get unwanted calls from third parties</li>
        </ul>
    </div>
    <div class="p-4 col-12 w-50">
        <h5 class="mb-4 fw-bold">Looking for an admission at Success Paramedical Institute. Give us your details and
            we will help you!</h5>
        <form>
            <div class="billing-details">
                <div class="mb-3">
                    <input type="text" class="form-control" placeholder="Name *" required>
                </div>
                <div class="mb-3">
                    <input type="text" class="form-control" placeholder="Mobile No *" required>
                </div>
                <div class="mb-3">
                    <input type="email" class="form-control" placeholder="Email *" required>
                </div>
                <div class="mb-3">
                    <div class="form-group">
                        <label>Courses Level <span class="required">*</span></label>
                        <div class="select-box">
                            <select>
                                <option>U.G & P.G COURSES</option>
                                <option>12th PASS (SCI / COM /ARTS)</option>
                                <option>12th SCI-PASS COURSES</option>
                                <option>MSCMLT</option>
                                <option>PGDMLT</option>
                                <option>BSC NURSING</option>
                                <option>PGDGOVERNMENT COURSESMLT</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="form-group">
                        <label>Preferred Stream <span class="required">*</span></label>
                        <div class="select-box">
                            <select>
                                <option>Microbiology</option>
                                <option>Bio Chemistry</option>
                                <option>Bio Technology</option>
                            </select>
                        </div>
                    </div>
                </div>
                <button type="submit" class="default-btn"><span></span>Submit</button>
            </div>
        </form>
    </div>
</div>
<i class="fa-solid fa-xmark position-absolute top-0 end-0 m-3" (click)="close()"></i> -->
<div class="container-fluid p-0">
    <div class="row g-0">

        <!-- LEFT SECTION -->
        <div class="col-lg-6 col-md-12 bg-color text-white p-4">
            <h5 class="mb-4 text-white fw-bold">Why register with us?</h5>
            <ul class="mb-0">
                <li>With totally online Admission Process we help you get college admission without having to step out
                </li>
                <li>Up to 50% discount on application forms</li>
                <li>Upload your admission documents and get Paytm rewards</li>
                <li>You won’t get unwanted calls from third parties</li>
            </ul>
            <div class="success-popup" *ngIf="isSuccessPopup">
                <p class="mb-0 text-white">{{ successMessage }}</p>
            </div>
        </div>

        <!-- RIGHT SECTION -->
        <div class="col-lg-6 col-md-12 p-4">
            <h5 class="mb-4 fw-bold">
                Looking for an admission at Success Paramedical Institute.
                Give us your details and we will help you!
            </h5>

            <form [formGroup]="inquiryForm" (ngSubmit)="submitInquiry()">
                <div class="mb-3">
                    <input type="text" class="form-control" placeholder="Name *" formControlName="name" required>
                    <small class="text-danger"
                        *ngIf="inquiryForm.get('name')?.touched && inquiryForm.get('name')?.hasError('required')">
                        Name is required
                    </small>
                </div>

                <div class="mb-3">
                    <input type="text" class="form-control" placeholder="Mobile No *" formControlName="contactNo"
                        required>
                    <small class="text-danger"
                        *ngIf="inquiryForm.get('contactNo')?.touched && inquiryForm.get('contactNo')?.hasError('required')">
                        Mobile number is required
                    </small>
                    <small class="text-danger"
                        *ngIf="inquiryForm.get('contactNo')?.touched && inquiryForm.get('contactNo')?.hasError('pattern')">
                        Enter a valid 10-digit mobile number
                    </small>
                </div>

                <div class="mb-3">
                    <input type="email" class="form-control" placeholder="Email *" formControlName="email" required>
                    <small class="text-danger"
                        *ngIf="inquiryForm.get('email')?.touched && inquiryForm.get('email')?.hasError('required')">
                        Email is required
                    </small>
                    <small class="text-danger"
                        *ngIf="inquiryForm.get('email')?.touched && inquiryForm.get('email')?.hasError('email')">
                        Enter a valid email address
                    </small>
                </div>

                <div class="mb-3">
                    <textarea class="form-control" placeholder="Inquiry Description *"
                        formControlName="inquiryDescription" required></textarea>
                    <small class="text-danger" *ngIf="inquiryForm.get('inquiryDescription')?.touched &&
                      inquiryForm.get('inquiryDescription')?.hasError('required')">
                        Inquiry description is required
                    </small>
                </div>

                <button type="submit" class="default-btn w-100"
                    [disabled]="inquiryForm.invalid"><span></span>Submit</button>
            </form>
        </div>

    </div>
</div>

<!-- CLOSE BUTTON -->
<i class="fa-solid fa-xmark position-absolute top-0 end-0 m-3 fs-3 cursor-pointer" (click)="close()"></i>